'use client'

import CCP_ImageFallback from '@/components/main/element/ImageFallback'
import { useTranslations } from 'next-intl'

export default function NotFound() {
  const __t = useTranslations()

  return (
    <div className="tw-px-4 tw-h-[80vh] tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center">
      <CCP_ImageFallback
        src="https://static.bangkokhospital.com/uploads/2024/05/error.svg"
        width={128}
        height={128}
        alt="Error"
      />
      <h3 className="tw-text-center tw-max-w-3xl">
        {__t('sorry-page-not-found')}
      </h3>
      <div className="tw-mt-12 tw-flex tw-items-center tw-space-x-4">
        <a href={`/`}>{__t('go-to-homepage')}</a>
      </div>
    </div>
  )
}
